/**
 * Metric constants - browser-safe, zero imports.
 * This is the foundation file that other metric files build upon.
 */
const metricCanonicalNames = {
    WEIGHT: 'weight',
    REPS: 'reps',
    DURATION: 'duration',
    DISTANCE: 'distance',
    REP_PACE: 'rep-pace',
    HEIGHT: 'height',
};
// @todo: i don't like numeric. it doesn't specify (real, float, int)
const metricValueTypes = {
    NUMERIC: 'numeric',
    TEXT: 'text',
};
const metricTargetColumns = {
    targetWeightMetric: 'targetWeightMetric',
    targetRepsMetric: 'targetRepsMetric',
    targetDurationMetric: 'targetDurationMetric',
    targetDistanceMetric: 'targetDistanceMetric',
    targetRepPaceMetric: 'targetRepPaceMetric',
    targetHeightMetric: 'targetHeightMetric',
};
const metricActualColumns = {
    actualWeightMetric: 'actualWeightMetric',
    actualRepsMetric: 'actualRepsMetric',
    actualDistanceMetric: 'actualDistanceMetric',
    actualDurationMetric: 'actualDurationMetric',
    actualRepPaceMetric: 'actualRepPaceMetric',
    actualHeightMetric: 'actualHeightMetric',
};
const metricToColumnMap = {
    [metricCanonicalNames.WEIGHT]: {
        targetColumn: metricTargetColumns.targetWeightMetric,
        actualColumn: metricActualColumns.actualWeightMetric,
    },
    [metricCanonicalNames.REPS]: {
        targetColumn: metricTargetColumns.targetRepsMetric,
        actualColumn: metricActualColumns.actualRepsMetric,
    },
    [metricCanonicalNames.DURATION]: {
        targetColumn: metricTargetColumns.targetDurationMetric,
        actualColumn: metricActualColumns.actualDurationMetric,
    },
    [metricCanonicalNames.DISTANCE]: {
        targetColumn: metricTargetColumns.targetDistanceMetric,
        actualColumn: metricActualColumns.actualDistanceMetric,
    },
    [metricCanonicalNames.REP_PACE]: {
        targetColumn: metricTargetColumns.targetRepPaceMetric,
        actualColumn: metricActualColumns.actualRepPaceMetric,
    },
    [metricCanonicalNames.HEIGHT]: {
        targetColumn: metricTargetColumns.targetHeightMetric,
        actualColumn: metricActualColumns.actualHeightMetric,
    },
};
export { metricActualColumns, metricCanonicalNames, metricTargetColumns, metricToColumnMap, metricValueTypes, };
//# sourceMappingURL=metric.constants.js.map